import React, { useState, useEffect } from 'react'
import s from '@pagestyles/Blog.module.scss'
import Link from 'next/link'
import { useTranslation } from 'react-i18next'
import getBlogrecentpost, {
    RecentBlogPost
} from '@pylot-data/api/operations/get-blogrecentpost'
import Image from '@corratech/pylot-image'
import { authorTime } from '@components/common/CMSBlockConst/cms-block-util'
import { useRouter } from 'next/router'

export const RecentPost: React.FC = () => {
    const { t } = useTranslation(['blog'])
    const [recentPosts, setRecentPosts] = useState<RecentBlogPost[]>([])
    const posturlbannerlink = '/blog/'
    const router = useRouter()
    const { locale } = router
    useEffect(() => {
        const getblogrecentpost = async () => {
            const blogData = await getBlogrecentpost({
                pageSize: 5,
                locale: locale || ''
            })
            if (!blogData) {
                return {
                    notFound: true
                }
            }
            await setRecentPosts(blogData.blogPosts.items)
        }

        getblogrecentpost()
    }, [])

    if (!recentPosts?.length) return null

    return (
        <div>
            <h2>
                {t(recentPosts.length === 1 ? 'Recent Post' : 'Recent Posts')}
            </h2>
            <div className={s['popularPost']}>
                {recentPosts?.map((post: RecentBlogPost, index: number) => {
                    return (
                        <div className={s['popularList']} key={post?.post_id}>
                            <div className={s['popularpostImg']}>
                                <Link
                                    href={`${posturlbannerlink}${post.identifier}`}
                                >
                                    <Image
                                        src={post?.featured_list_image}
                                        width={920}
                                        height={625}
                                        alt={post?.title}
                                    />
                                </Link>
                            </div>
                            <div className={s['popularpostcontent']}>
                                <div className={s['tagLink']}>
                                    <Link
                                        href={`${posturlbannerlink}${post.identifier}`}
                                    >
                                        {post?.title}
                                    </Link>
                                </div>
                                <p>{authorTime(post)}</p>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
